/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ActionHistoryResponse,
    ActionHistoryResponseFromJSON,
    ActionHistoryResponseToJSON,
    BadRequestErrorResponse,
    BadRequestErrorResponseFromJSON,
    BadRequestErrorResponseToJSON,
} from '../models';

export interface ReadActionHistoryElementsRequest {
    filter?: string | null;
    offset?: number | null;
    limit?: number | null;
}

/**
 * 
 */
export class ActionHistoryApi extends runtime.BaseAPI {

    /**
     * Read action history.
     */
    async readActionHistoryElementsRaw(requestParameters: ReadActionHistoryElementsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ActionHistoryResponse>> {
        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/actionHistory`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActionHistoryResponseFromJSON(jsonValue));
    }

    /**
     * Read action history.
     */
    async readActionHistoryElements(requestParameters: ReadActionHistoryElementsRequest = {}, initOverrides?: RequestInit): Promise<ActionHistoryResponse> {
        const response = await this.readActionHistoryElementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
